import React, { Component } from "react";
import QRCode from "qrcode.react";
import Select from "react-select";
import db from "../firebase";
import { notify } from "react-notify-toast";

export default class Qr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branchId: "",
      options: [{}],
      startRange: 1,
      endRange: 2,
      qrs: [],
      qrra: [{ id: "1" }],
      user: JSON.parse(localStorage.getItem("Ubytes")),
    };
    this.loadBranch = this.loadBranch.bind(this);
  }
  async loadBranch(id, merchant = false) {
    if (merchant) {
      var data = await db.collection("Branches").where("of", "==", id).get();
      var data_ = [];
      data.forEach((k) => {
        var _ = k.data();
        _["value"] = k.data().branchId;
        _["label"] = k.data().branchName;
        data_.push(_);
      });
      this.setState({ options: data_ });
      return;
    }
    var data = await db
      .collection("Branches")
      .doc(this.state.user.branchId)
      .get();
    var _ = data.data();
    _["value"] = data.data().branchId;
    _["label"] = data.data().branchName;

    this.setState({ options: _ });
  }
  componentDidMount() {
    if (this.state.user.role === "Branch") {
      this.loadBranch(this.state.user.branchId);
    } else {
      this.loadBranch(this.state.user.of, true);
    }
  }
  qrGenerate = () => {
    if (!this.state.from || !this.state.to) {
      notify.show("Please select table range", "warning");
      return;
    }
    if (this.state.from > this.state.to) {
      notify.show("Please fill range properly", "warning");
      return;
    }
    if (this.state.user.role != "Branch") {
      if (!this.state.selectedBranch) {
        notify.show("Please select Branch", "warning");
        return;
      }
    }
    let qrs = [];

    for (let index = this.state.from; index <= this.state.to; index++) {
      let url =
        this.state.user.role === "Branch"
          ? window.origin +
            "/" +
            this.state.user.of +
            "/dine-in/" +
            this.state.user.branchId
          : window.origin +
            "/" +
            this.state.user.uid +
            "/dine-in/" +
            this.state.selectedBranch.branchId +
            "/" +
            index;
      let payload = { tableNumber: index, id: index, value: url };
      qrs.push(payload);
    }
    this.setState({ qrs: qrs });
  };
  from = (value) => {
    this.setState({ from: value });
  };
  to = (value) => {
    this.setState({ to: value });
  };
  downloadQR = (id, index) => {
    const canvas = document.getElementById(id);
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "image-qr.png";
    if (this.state.selectedBranch.branchId) {
      /* let data=sessionStorage.getItem('branchData')
      data=JSON.parse(data) */
      downloadLink.download = `${this.state.selectedBranch.branchName}-${index}.png`;
    }
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  render() {
    return (
      <div className="qr-body">
        <div
          className="qr-branch-select"
          style={{ width: "100%", marginBottom: "1%" }}
        >
          <a>
            Merchant :{" "}
            {this.state.user.role === "Merchant"
              ? this.state.user.brandName
              : this.state.user.ofMerchant}
          </a>
        </div>
        <div className="qr-branch-select">
          <a>Select Branch:</a>

          {this.state.user.role === "Branch" ? (
            this.state.user.branchName
          ) : (
            <Select
              onChange={(e) => this.setState({ selectedBranch: e })}
              placeholder="Enter Branch id here"
              options={this.state.options}
            ></Select>
          )}
        </div>
        <div
          className="qr-branch-select"
          style={{
            width: "100%",
            marginTop: "1%",
            justifyContent: "flex-start",
          }}
        >
          <small>From:</small>
          <input
            onChange={(e) => this.from(e.target.value)}
            value={this.state.from}
            type="number"
            placeholder="From "
          ></input>
          <small>To:</small>
          <input
            value={this.state.to}
            onChange={(e) => this.to(e.target.value)}
            type="number"
            placeholder="To"
          ></input>
          <button onClick={this.qrGenerate}>Generate</button>
        </div>
        <div className="qr-grid">
          {this.state.qrs.map((k, index) => (
            <div key={index} className="qr-section">
              <small>Table Number {k.tableNumber}</small>
              <QRCode
                imageSettings={{ width: 220, height: 220 }}
                value={k.value}
                size={220}
                id={k.id}
              ></QRCode>
              <a
                style={{ color: "white" }}
                onClick={() => this.downloadQR(k.id, index)}
              >
                {" "}
                Download QR{" "}
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
